import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { MobileTimePicker } from "@mui/x-date-pickers";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
 
const TimeComponent = (props: any) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MobileTimePicker
        label={props.label ? props.label : "Time"}
        value={props?.value}
        onChange={props?.onChange}
        ampm={props.ampm !== undefined ? props.ampm : false}
        views={props.views ? props.views : ["hours", "minutes"]}
        format={props.inputFormat ? props.inputFormat : "HH:mm"}
        readOnly={props.readOnly || false}
        onAccept={props?.onAccept}
        onClose={props?.onClose}
        slotProps={{
          textField: {
            error: props.value !== "" && props.error ? true : false,
            id: props.id,
            name: props.name,
            size: props.size || "small",
            value: props.value ? props.value : null,
            required: props?.isrequired || false,
            variant: "outlined",
            sx: {
              minWidth: "100%",
              "& .MuiInputLabel-asterisk": {
                color: "#E60000",
              },
            },
            label: props?.label ? props?.label : "Time",
            helperText: props?.value !== "" && props.error,
            onBlur: props.inputOnBlur,
            onChange: props.inputOnchange,
            autoComplete: "off",
            InputProps:{
              endAdornment: (<AccessTimeIcon sx={{color:"#708090","&:hover":{cursor:'pointer'}}}/>),
            }
          },
        }}
      />
    </LocalizationProvider>
  );
};
 
export default TimeComponent;